import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { firstListItem } from '@/constants/defaultValues';
import { apiPath } from '@/constants/defaultValues';
import { Delete, Get, PostBlob, Post } from '@/api/api-middleware';
import { getCompanyID, getEmployeeID } from '@/helpers/Utils';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  qualificationTypeList: [],
  scheduleCatgory: {},
  loading: false,
  error: '',
};

export const fetAllQualificationTypes = createAsyncThunk(
  'qualificationType/fetAllQualificationTypes',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}api/Lookup/Employee/GetAllQualificationType`,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addScheduleCategory = createAsyncThunk(
  'scheduleCategory/addScheduleCategory',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Lookup/ScheduleCategory/Add'}`,
        data: params,
      });
      thunkAPI.fetchScheduleCategory();
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const qualificationTypeSlice = createSlice({
  name: 'qualificationType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetAllQualificationTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetAllQualificationTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.qualificationTypeList = action.payload;
        state.error = '';
      })
      .addCase(fetAllQualificationTypes.rejected, (state, action) => {
        state.loading = false;
        state.qualificationTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(addScheduleCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(addScheduleCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.scheduleCatgory = action.payload;
        state.error = '';
      })
      .addCase(addScheduleCategory.rejected, (state, action) => {
        state.loading = false;
        state.scheduleCatgory = {};
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default qualificationTypeSlice.reducer;
